// extracted by mini-css-extract-plugin
export default {"container":"Metadata-module__container__iYXy3Ih","heading":"Metadata-module__heading__XcDEQzf"};